import {Avatar, Button, DatePicker, Input, Modal} from 'antd'
import {course_getCourseClasses_Api} from 'apis'
import {getId} from 'apis/model/base'
import classNames from 'classnames'
import FieldsFactory from 'components/form/FieldsFactory'
import {FormActionGroups} from 'components/form/FormActionBar'
import {createValue} from 'components/form/utils'
import {Formik} from 'formik'
import getTitle from 'helpers/getTitle'
import {getDateString, parseDayjs} from 'helpers/datetimeHelpers'
import _ from 'lodash'
import Translate from 'modules/local/Translate'
import useTranslate from 'modules/local/useTranslate'
import withTranslate from 'modules/local/withTranslate'
import React, {useCallback, useContext, useMemo, useState} from 'react'
import {BsCaretDownFill, BsCaretRightFill} from 'react-icons/bs'
import {IoCalendarOutline} from 'react-icons/io5'
import {RiListCheck2, RiSignalTowerFill, RiUserSharedLine} from 'react-icons/ri'
import {useLocation} from 'react-use'
import {compose, mapProps, nest, pure, withProps} from 'recompose'
import {FetchClassById} from 'views/AppLocals/Course/components/FetchEntity'
import {NullAsDefault, pagerControls, renderIf, renderSelf, shallowDiff,} from 'views/Shared'
import {bindingSearch} from 'views/Shared/components/PagerControls'
import {renderCourseClass} from 'views/Workspace/Course/functions/renderCourseClass'
import {ClassActionTypes} from '..'
import {gConfigs} from '../../configs'
import {appClassNames} from '../../custom/appClassNames'
import EntityList from '../../EntityList'
import {showDeleteConfirmDialog} from '../../factory/createConfirmDialog'
import createContextMenu from '../../factory/createContextMenu'
import {createControlledFormField} from '../../factory/createFormField'
import {bindQueryParam} from '../../functions/routerHelper'
import {HeaderWithIconLine, ListHeaderLineAndDes, ListHeaderWithLine} from '../../Templates/items/ListHeader'
import {CourseSelector} from '../components/CourseSelector'
import {TeacherSelector} from '../components/TeacherSelector'
import {CourseClassStudentList} from './CourseClassStudentForm'
import {CourseClassTimetables} from './CourseClassTimetableForm'
import {useCourseClassApi} from './useCourseClassApi'
import {CustomToggleField} from "../../../../components/form/fields/ToggleField";
import WorkspaceContext from "../../../Workspace/WorkspaceContext";
import LookupField from "../../../../components/LookupField";
import TooltipApp from "../../../../components/TooltipApp";
import Pure from "../../../../components/Pure";
import useToggle from "react-use/lib/useToggle";
import {FaUserTie} from "react-icons/fa6";
import {BiSolidEdit, BiTrash} from "react-icons/bi";
import {renderIfElse} from "../../../Shared";
import {Link} from "react-router-dom";
import getLinkToDetail from "../../../../helpers/getLinkToDetail";
import {ItemInformation} from "../../Organization/OrganizationEntity";
import {LayoutContext} from "../../../../components/layouts/Default/LayoutContext";
import {DoubleValueItem} from "../../CatholicHousehold/components/CatholicHouseholdComponents";
import {FaChalkboardTeacher} from "react-icons/fa";
import dayjs from "dayjs";
import {formatDate} from "../../../../helpers/datetimeHelpers";
import {ActionModalWrapper} from "../../../../components/form/ActionModalWrapper";
import {ROOT_URL} from "../../../../envs/_current/config";
import LoadingBlock from "../../../LoadingBlock";

const Coordinators = ({form, name, value, defaultValue = [], handleChange = NullAsDefault, ...props}) => {
    const t = useTranslate()
    const {isSm} = useContext(LayoutContext)
    const timetable_teachers = value || defaultValue;
    const {organization} = useContext(WorkspaceContext)

    return (
        <div className="flex flex-col gap-3">
            <div className="flex">
                <LookupField
                    title={t('teacher/supervisor')}
                    createIfNotExists={true}
                    placeholder={t('click to select / create')}
                    apiPath={`/lookup/teacher/get-by-types?owner_type=organization&owner_id=${organization?.id}`}
                    OptionWrapper={({children, ...props}) =>
                        <div className="flex items-center gap-2 border border-color-50 hover:shadow-md rounded-lg relative" {...props}>
                            {children}
                        </div>
                    }
                    renderOption={(o, i) => {
                        return (
                            <div key={i} className="flex items-center flex-1 gap-3">
                                {renderIf(
                                    !isSm,
                                    <Avatar
                                        size={50}
                                        src={o?.user?.avatar || o.avatar}
                                        className="flex flex-center background-200 rounded-l-lg rounded-r-0"
                                        icon={<FaUserTie size={20} style={{color: '#dddddd'}}/>}
                                    />
                                )}
                                <div className="flex flex-col">
                                        <span className="font-bold text-color-000 leading-snug">
                                            {o?.prefix_title || ""} {o?.fullname}
                                        </span>
                                    <ItemInformation label="teacher code" value={_.get(o, 'teacher_idcode')}
                                                     className="text-2xs italic"/>
                                </div>
                            </div>
                        )
                    }}
                    handleChange={(e) => {
                        let _timetable_teachers = _.cloneDeep(timetable_teachers);

                        const teacher = _.find(_timetable_teachers, {id: e.target.id});
                        if (!teacher) {
                            _timetable_teachers.push({
                                teacher: e.target,
                                teacher_name: e.target.value,
                                teacher_id: e.target.id,
                                id: e.target.id || e.target.value,
                            });
                            handleChange(_timetable_teachers)
                        }
                    }}
                />
            </div>
            <div className="grid grid-cols-1 md:grid-cols-2 gap-2 md:gap-3">
                {timetable_teachers.map((timetable_teacher, idx) => {
                    const {teacher, teacher_name} = timetable_teacher ?? {}
                    return (
                        <div key={idx} className="py-2 rounded-md custom-item-render custom-render-border relative">
                            {renderIfElse(
                                teacher,
                                <div className="flex items-center gap-2">
                                    <Avatar
                                        size={30}
                                        src={teacher?.user?.avatar || teacher?.avatar}
                                        icon={<FaUserTie size={16} className="text-color-500"/>}
                                        className="flex flex-center background-200"
                                    />
                                    <div className="flex flex-col flex-1">
                                        <Link to={getLinkToDetail(teacher)}
                                              className="font-bold text-color-000 no-underline leading-snug">
                                            {teacher?.prefix_title || ""} {getTitle(teacher)}
                                        </Link>
                                        <ItemInformation label="teacher code" value={_.get(teacher, 'teacher_idcode')}
                                                         className="text-2xs italic"/>
                                    </div>
                                </div>,
                                <div className="font-bold text-color-000">
                                    {teacher_name}
                                </div>
                            )}
                            <BiTrash
                                onClick={() => {
                                    let _timetable_teachers = _.cloneDeep(timetable_teachers);
                                    showDeleteConfirmDialog({
                                        translate: t,
                                        title: 'delete teacher',
                                        message: 'are you sure you want to delete it teacher',
                                        onOk: () => {
                                            _.remove(_timetable_teachers, {id: timetable_teacher?.id});
                                            handleChange(_timetable_teachers)
                                        },
                                    })
                                }}
                                className="absolute top-5 right-5 contextIcon text-primary-200 hover:text-primary cursor-pointer"
                            />
                        </div>
                    )
                })}
            </div>
        </div>
    )
}

const formSchema = {
    title: {
        title: 'name of class',
        children: [
            {
                name: 'title',
                component: createControlledFormField({
                    placeholder: 'name of class',
                }),
            },
        ],
    },
    description: {
        title: 'short description',
        children: [
            {
                name: 'description',
                component: createControlledFormField({
                    rows: 4,
                    placeholder: 'short description',
                    Component: Input.TextArea,
                    className: 'scrollBarThin'
                }),
            },
        ],
    },
    idname: {
        title: 'url',
        children: {
            name: 'idname',
            component: compose(
                mapProps(({onChange, value}) => ({
                    onChange,
                    value,
                    name: 'idname',
                    addonBefore: 'https://.../classroom/',
                    placeholder: 'please input name!',
                    type: 'text',
                    trigger: ['focus'],
                    title: ROOT_URL + '/classroom/' + value,
                    placement: 'topLeft',
                    disabled: true,
                })),
                pure
            )(nest(TooltipApp, Input)),
        },
    },
    channel_privacy: {
        title: 'private channel',
        children: {
            name: 'channel_privacy',
            component: compose(
                withTranslate,
                mapProps(({name, value, onChange, translate}) => ({
                    name,
                    value: Number(value) === 2,
                    onChange: (value) => {
                        onChange(createValue(name, Boolean(value) ? 2 : 1))
                    },
                    title: translate('private channel'),
                    description: translate(
                        'by making a channel private, only members will have access to this channel'
                    ),
                }))
            )(CustomToggleField),
        },
    },
    channel_post_permission: {
        title: 'posting permission',
        children: {
            name: 'channel_post_permission',
            component: compose(
                withTranslate,
                mapProps(({name, value, onChange, translate}) => ({
                    name,
                    value: Number(value) === 3,
                    onChange: (value) => {
                        onChange(createValue(name, Boolean(value) ? 3 : 2))
                    },
                    title: translate('posting permission'),
                    description: translate("Allow changing posting permissions on the news channel; On: only administrators are allowed to post, Off: all students are allowed to post"),

                }))
            )(CustomToggleField),
        },
    },
    container: {
        title: 'choose course',
        children: [
            {
                name: 'course',
                component: mapProps(({name, value, form, onChange}) => {
                    const {owner_id, owner_type} = form?.values ?? {}
                    return {
                        name,
                        value,
                        onChange,
                        owner_id,
                        owner_type,
                    }
                })(CourseSelector),
            },
        ],
    },
    class_coordinator: {
        title: 'class coordinator',
        children: [
            {
                name: 'class_coordinator',
                component: mapProps(({name, value, form, onChange}) => {
                    const {owner_id, owner_type} = form?.values ?? {}
                    return {
                        name,
                        value,
                        onChange,
                        owner_id,
                        owner_type,
                    }
                })(TeacherSelector),
            },
        ],
    },
    coordinators: {
        // title: 'coordinators',
        children: [
            {
                name: 'coordinators',
                component: createControlledFormField({
                    className: 'w-full',
                    Component: Coordinators,
                    withForm: ({...props}) => ({form: {...props}}),
                    withProps: ({name, value, onChange, ...props}) => ({
                        defaultValue: value,
                        handleChange: (_value) => {
                            onChange(createValue(name, _value))
                        },
                        ...props
                    }),
                    withValues: ({resetKey}) => ({
                        resetKey,
                    }),
                }),
            },
        ],
    },
    started_finished_date: {
        inline: true,
        className: appClassNames.inline_2,
        children: [
            {
                name: 'from_date',
                label: 'from date',
                component: compose(
                    withTranslate,
                    mapProps(({name, value, onChange, translate}) => ({
                        name,
                        value,
                        className: 'w-full',
                        format: gConfigs.dateFormat,
                        suffixIcon: <IoCalendarOutline className="text-color-500"/>,
                        placeholder: translate('ex: 20/10/2010'),
                        onChange: (date, dateString) => {
                            onChange(createValue(name, date ? dayjs(new Date(date)) : null))
                        },
                    }))
                )(DatePicker),
            },
            {
                name: 'to_date',
                label: 'to date',
                component: compose(
                    withTranslate,
                    mapProps(({name, value, onChange, translate}) => ({
                        name,
                        value,
                        className: 'w-full',
                        format: gConfigs.dateFormat,
                        suffixIcon: <IoCalendarOutline className="text-color-500"/>,
                        placeholder: translate('ex: 20/10/2010'),
                        onChange: (date, dateString) => {
                            onChange(createValue(name, date ? dayjs(new Date(date)) : null))
                        },
                    }))
                )(DatePicker),
            },
        ],
    },
}

const CourseInfo = ({item, style, className}) => {
    const t = useTranslate()
    const {time_open, time_close} = item ?? {}

    return (
        <Translate>
            {(t) => (
                <div
                    style={style}
                    className={classNames(
                        'flex items-center gap-3 rounded-lg custom-border-primary ',
                        className
                    )}>
                    <Avatar
                        size={60}
                        icon={<FaChalkboardTeacher size={30} className="text-primary-400"/>}
                        className="flex flex-center bg-primary-50 rounded-l-lg rounded-r-0"
                    />
                    <div className="flex flex-col flex-1">
                        <div className="font-bold text-color-000">
                            {getTitle(item)}
                        </div>
                        {renderIf(
                            _.some([time_open, time_close]),
                            <DoubleValueItem
                                showIcon={true}
                                labelFirst="time"
                                valueFirst={formatDate(time_open, 'DD/MM/YYYY')}
                                labelSecond={time_close && ' - ' || ''}
                                valueSecond={time_close && formatDate(time_close, 'DD/MM/YYYY')}
                                className="text-xs italic"
                            />
                        )}
                    </div>
                </div>
            )}
        </Translate>
    )
}

export const CreateCourseClassModal = ({
                                           owner_id,
                                           owner_type,
                                           container,
                                           onSubmit = NullAsDefault,
                                       }) => {
    const t = useTranslate()

    const initialValues = useMemo(
        () => ({
            owner_id,
            owner_type,
            title: undefined,
            description: undefined,
        }),
        [owner_id, owner_type]
    )

    const validate = (values) => {
        let errors = {}

        const {title, course, to_date, from_date} = values ?? {}

        if (!title) {
            errors.title = t('required field')
        }

        if (!to_date) {
            errors.to_date = t('required field')
        }

        if (!from_date) {
            errors.from_date = t('required field')
        }

        if (!container && !course) {
            errors.course = t('required field')
        }

        if (!container && !from_date) {
            errors.from_date = t('required field')
        }

        if (!container && !to_date) {
            errors.to_date = t('required field')
        }

        return errors
    }

    return (
        <Formik
            onSubmit={(values) => {
                const {
                    course,
                    owner_id,
                    owner_type,
                    to_date,
                    from_date,
                    coordinators,
                    ...rest
                } = values ?? {}
                onSubmit(
                    _.omitBy(
                        {
                            ...rest,
                            course_id: getId(course),
                            to_date: getDateString(to_date),
                            from_date: getDateString(from_date),
                            coordinators: JSON.stringify(coordinators),
                        },
                        _.isUndefined
                    )
                )
            }}
            validate={validate}
            validateOnMount={true}
            validateOnChange={true}
            enableReinitialize={true}
            initialValues={initialValues}>
            <ActionModalWrapper
                action={<FormActionGroups submitProps={{label: 'create'}}/>}>
                {container ? (
                    <CourseInfo item={container}/>
                ) : (
                    <FieldsFactory formSchema={[formSchema.container]}/>
                )}
                <FieldsFactory
                    formSchema={[
                        formSchema.title,
                        formSchema.started_finished_date,
                    ]}
                />
                <div className="flex flex-col gap-2 pt-4">
                    <HeaderWithIconLine
                        icon={<FaUserTie size={15} className="text-color-500 mr-1"/>}
                        title="coordinators"
                        className="text-base text-color-300"
                    />
                    <Pure>
                        <FieldsFactory formSchema={[formSchema.coordinators]}/>
                    </Pure>
                </div>
            </ActionModalWrapper>
        </Formik>
    )
}

export const EditCourseClassModal = ({
                                         item,
                                         owner_id,
                                         owner_type,
                                         container,
                                         onSubmit = NullAsDefault,
                                     }) => {
    const t = useTranslate()
    const location = useLocation()
    const [isToggle, toggle] = useToggle()
    const refreshKey = location?.state?.refreshToken

    const validate = (values) => {
        let errors = {}

        const {title, course, to_date, from_date} = values ?? {}

        if (!title) {
            errors.title = t('required field')
        }

        if (!to_date) {
            errors.to_date = t('required field')
        }

        if (!from_date) {
            errors.from_date = t('required field')
        }

        if (!container && !course) {
            errors.course = t('required field')
        }

        return errors
    }

    const initialValues = useMemo(() => {
        const {to_date, from_date, ...rest} = item ?? {}
        return {
            ...rest,
            owner_id,
            owner_type,
            refreshKey,
            to_date: parseDayjs(to_date),
            from_date: parseDayjs(from_date),
        }
    }, [item, owner_id, owner_type, refreshKey])

    return (
        <Formik
            onSubmit={(values) => {
                const {course, to_date, from_date, coordinators, ...changed} = shallowDiff(values, initialValues)
                const course_id = values?.course ? getId(course) : null
                onSubmit(
                    _.omitBy(
                        {
                            ...changed,
                            course_id,
                            to_date: getDateString(to_date),
                            from_date: getDateString(from_date),
                            coordinators: JSON.stringify(coordinators),
                        },
                        _.isUndefined
                    )
                )
            }}
            validate={validate}
            validateOnMount={true}
            validateOnChange={true}
            enableReinitialize={true}
            initialValues={initialValues}>
            <ActionModalWrapper
                action={<FormActionGroups submitProps={{label: 'save'}}/>}>
                {!container && (
                    <FieldsFactory formSchema={[formSchema.container]}/>
                )}
                <FieldsFactory
                    formSchema={[
                        formSchema.title,
                        formSchema.started_finished_date,
                        formSchema.description,
                    ]}
                />

                <div className="flex flex-col gap-2 pt-4">
                    <HeaderWithIconLine
                        icon={<FaUserTie size={15} className="text-color-500 mr-1"/>}
                        title="coordinators"
                        className="text-base text-color-300"
                    />
                    <Pure>
                        <FieldsFactory formSchema={[formSchema.coordinators]}/>
                    </Pure>
                </div>

                <div className="flex flex-col gap-2 pt-3">
                    <ListHeaderLineAndDes
                        renderTitle={() => (
                            <div className="flex items-start gap-1">
                                <RiSignalTowerFill size={15} className="text-color-500 mr-1"/>
                                <div
                                    className="flex-1 font-bold text-base text-color-300 uppercase tracking-wide leading-tight">
                                    {t('channel')}
                                </div>
                            </div>
                        )}
                        description="Manage administrative parameters related to the news channel"
                        extra={
                            <TooltipApp title={t('click to expand')} placement="bottomRight"
                                        classNames={{root: "text-xs italic"}}>
                                <Avatar
                                    size={22}
                                    className="flex flex-center bg-blue-100 hover:bg-blue-200 rounded-xs cursor-pointer"
                                    icon={isToggle ? <BsCaretDownFill size={12} className="text-blue-600"/> :
                                        <BsCaretRightFill size={12} className="text-blue-600"/>}
                                    onClick={() => toggle()}
                                />
                            </TooltipApp>
                        }
                    />
                    {isToggle && (
                        <Pure>
                            <FieldsFactory
                                formSchema={[
                                    formSchema.channel_privacy,
                                    formSchema.channel_post_permission,
                                ]}
                            />
                        </Pure>
                    )}
                </div>

            </ActionModalWrapper>
        </Formik>
    )
}

export const CourseClassList = ({
                                    item,
                                    owner_id,
                                    owner_type,
                                    header = null,
                                    controls = pagerControls,
                                    renderFooter = renderSelf,
                                }) => {
    const t = useTranslate()

    const course_id = getId(item)

    const [action, setAction] = useState({
        type: undefined,
        value: undefined,
    })

    const onCancel = () => {
        setAction({})
    }

    const {
        onCreate = NullAsDefault,
        onUpdate = NullAsDefault,
        onDelete = NullAsDefault,
        ...rest
    } = useCourseClassApi({
        onCreated: onCancel,
        onUpdated: onCancel,
        onDeleted: onCancel,
    })

    const apiInfo = course_getCourseClasses_Api

    const {keyword, component: search_widget} = controls?.search ?? {}

    const refreshKey = useMemo(
        () =>
            [
                apiInfo?.path?.replace(':id', course_id),
                JSON.stringify(keyword),
                rest.refreshKey,
            ].join(','),
        [keyword, course_id, rest.refreshKey]
    )

    const handleAction = (action, params) => {
        const {id} = params ?? {}
        switch (action) {
            case ClassActionTypes.CLASS_CREATE:
            case ClassActionTypes.CLASS_UPDATE:
            case ClassActionTypes.SHOW_STUDENT_LIST_MODAL:
            case ClassActionTypes.SHOW_TIMETABLE_LIST_MODAL:
                setAction({type: action, value: params})
                break
            case ClassActionTypes.CLASS_DELETE:
                if (id) {
                    showDeleteConfirmDialog({
                        translate: t,
                        title: 'delete course class',
                        message: 'are you sure you want to delete this course class',
                        onOk: () => {
                            onDelete({}, {id})
                        },
                    })
                }
                break
            default:
                break
        }
    }

    const renderContextMenu = useCallback(
        (item) =>
            createContextMenu(
                [
                    {
                        icon: <RiListCheck2 size={14} className="text-green-500"/>,
                        label: 'timetables',
                        key: ClassActionTypes.SHOW_TIMETABLE_LIST_MODAL,
                    },
                    {
                        icon: <RiUserSharedLine size={14} className="text-color-400"/>,
                        label: 'students',
                        key: ClassActionTypes.SHOW_STUDENT_LIST_MODAL,
                    },
                    {
                        icon: <BiSolidEdit size={14} className="text-blue-500"/>,
                        label: 'edit',
                        key: ClassActionTypes.CLASS_UPDATE,
                    },
                    {
                        icon: <BiTrash size={14} className="text-primary-300"/>,
                        label: 'delete',
                        key: ClassActionTypes.CLASS_DELETE,
                    },
                ].filter((e) => item),
                (key) => {
                    handleAction(key, item)
                }
            ),
        []
    )

    const modal = useMemo(() => {
        let params = {}
        let modal_params = {}
        let Component = NullAsDefault
        let Wrapper = ({children}) => children({item: {}})
        const id = getId(action?.value)
        switch (action?.type) {
            case ClassActionTypes.CLASS_CREATE:
                Component = CreateCourseClassModal
                modal_params = {
                    title: (
                        <div className="text-center font-bold text-color-000 uppercase tracking-wide">
                            {t('create class')}
                        </div>
                    ),
                }
                params = {
                    container: item,
                    onSubmit: (values) => {
                        onCreate(values, {id: course_id})
                    },
                }
                break
            case ClassActionTypes.CLASS_UPDATE:
                Wrapper = withProps({id})(FetchClassById)
                Component = EditCourseClassModal
                modal_params = {
                    title: (
                        <div className="text-center font-bold text-color-000 uppercase tracking-wide">
                            {t('edit class')}
                        </div>
                    ),
                }
                params = {
                    container: item,
                    onSubmit: (values) => {
                        onUpdate(values, {id})
                    },
                }
                break
            case ClassActionTypes.SHOW_STUDENT_LIST_MODAL:
                Wrapper = withProps({id})(FetchClassById)
                Component = (props) => bindingSearch(props)(CourseClassStudentList)
                modal_params = {
                    title: (
                        <div className="font-bold text-color-000 tracking-wide 222-222">
                            {t('students of class')}
                        </div>
                    ),
                }
                break
            case ClassActionTypes.SHOW_TIMETABLE_LIST_MODAL:
                Component = CourseClassTimetables
                Wrapper = withProps({id})(FetchClassById)
                modal_params = {
                    title: (
                        <div className="text-center font-bold text-color-000 uppercase tracking-wide">
                            {t('timetables')}
                        </div>
                    ),
                }
                break
            default:
                break
        }
        return (
            <Modal
                width={720}
                footer={null}
                onCancel={onCancel}
                open={action?.type}
                destroyOnHidden={true}
                className="custom-modal"
                {...modal_params}>
                <Wrapper>
                    {({item, isLoading}) => {
                        if (!!isLoading) {
                            return <LoadingBlock/>
                        }
                        return (
                            <Component
                                {...params}
                                {...{item, onCancel, owner_id, owner_type}}
                            />
                        )
                    }}
                </Wrapper>
            </Modal>
        )
    }, [action, course_id, owner_id, owner_type])

    return (
        <ActionModalWrapper className="flex-1 p-3">
            {header}
            <div className="flex flex-col gap-3 flex-1">
                <ListHeaderWithLine
                    className="text-sm"
                    title="list of classes"
                    extra={
                        <Button
                            size="small"
                            type="primary"
                            className="flex flex-center button-rounded-md no-border font-medium text-xs px-4"
                            onClick={() => {
                                handleAction(ClassActionTypes.CLASS_CREATE)
                            }}>
                            {t('create')}
                        </Button>
                    }
                />
                {search_widget}
                <EntityList
                    key={refreshKey}
                    apiInfo={apiInfo}
                    values={{keyword}}
                    RenderEntity={React.Fragment}
                    query={bindQueryParam({id: course_id})}
                    renderItem={renderCourseClass({renderContextMenu})}
                />
            </div>
            {renderFooter(null)}
            {modal}
        </ActionModalWrapper>
    )
}

